import React from 'react';
import noAuthPng from '@/static/images/no_auth.png';

type Props = {};

const NoAuth: React.FC<Props> = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '90px' }}>
      <img style={{ width: '200px', height: '200px' }} src={noAuthPng} />
      <div
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#617288',
          lineHeight: '24px',
          marginTop: '24px',
        }}
      >
        抱歉，您无权访问此页面
      </div>
    </div>
  );
};

export default NoAuth;
